import React, { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import * as storage from '../../utils/storage';
import { logout, logoutSSO } from '../../actions/authentication';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import Button from '@material-ui/core/Button';

const Logout = (props) => {

    /**
     * useMsal is hook that returns the PublicClientApplication instance,
     * that tells you what msal is currently doing. For more, visit:
     * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/hooks.md
     */
    const { instance } = useMsal();

    useEffect(() => {

    }, []);

    const handleLogout = (instance) => {
        handleStatus(true);
        if (storage.getIsAuthSSO() == false) {
            logout();
        } else {
            logoutSSO(instance);
        }
    }

    const handleStatus = (status) => {
        props.handleStatus(status);
    }

    return (
        <div style={{ position: 'absolute', left: '0px', top: '10px', color: 'var(--color1)', fontSize: 22, zIndex: 999 }} >
            <Button startIcon={<FontAwesomeIcon icon={faArrowRightFromBracket} style={{ width: "25px", height: "25px" }} />} color="inherit" onClick={() => handleLogout(instance)}></Button>
        </div>
    )
}

export default Logout;